module.exports = __webpack_public_path__ + "img/pinned-assets-icon.36c153f3.svg";